<div class="books-page">

  <product-page
    [mainFilterName]="'foreign'"
    [filterName]="'foreign'"
    [productType]="'foreign'"
    [showFilters]="false"
    [pageName]="'foreign'"
  ></product-page>

</div>
